<template>
    <p class="installment-item-info" v-html="splitPrice()"></p>
</template>

<script>
  export default {
    name: "InstallmentSimulation",
    props: {
      price: Number
    },

    methods: {
      splitPrice()
      {
        let i_count = this.installmentsCount();
        let i_rate = ((Math.round(parseInt(this.price*100)/i_count)  ) / 100.0).toFixed(2);
        return `${i_rate} PLN x ${i_count} RAT 0%`;
      },
      installmentsCount()
      {
        if(this.price >= 5999) return 30;
        if(this.price >= 2999) return 20;
        return 10;
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Products/InstallmentSimulation.vue